import React, { useCallback, useState } from 'react';

import { CheckboxTick, Download } from '@stratumn/icons';
import filesize from 'filesize';
import injectSheet, { type ClassNameMap } from 'react-jss';

import styles from './item.style';

type Props = {
  classes: ClassNameMap<string>;
  file: {
    name: string;
    size: number;
  };
  downloadFile: (
    file: { name: string; size: number },
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    isLoading: boolean,
    setDownloadResponse: React.Dispatch<unknown>
  ) => void;
  name: string;
};

export const Item = ({ classes, file, downloadFile }: Props) => {
  const [hovered, setHovered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [downloadResponse, setDownloadResponse] = useState<unknown>(null);

  const handleMouseEnter = useCallback(() => setHovered(true), [hovered]);
  const handleMouseLeave = useCallback(() => setHovered(false), [hovered]);

  const renderDownloadStatus = () =>
    downloadResponse === null ? (
      <Download className={classes.labelIcon} />
    ) : (
      <CheckboxTick className={classes.labelTickIcon} />
    );

  const renderDownloadFile = () => (
    <div
      className={classes.label}
      data-cy={`download-file-${file.name}`}
      data-testid="download-file"
      onClick={() =>
        downloadFile(file, setIsLoading, isLoading, setDownloadResponse)
      }
    >
      {renderDownloadStatus()}
      <p>
        {file.name} <span>{filesize(file.size)?.split(' ').join('')}</span>
      </p>
    </div>
  );
  return (
    <div
      className={classes.root}
      data-cy="file-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      title={file.name}
    >
      <div className={classes.attachment}>{renderDownloadFile()}</div>
    </div>
  );
};

export default injectSheet(styles)(React.memo(Item));
